import { httpClient, ApiResponse } from '@/utils';
import {
  AuthEndpoints,
  IChangePasswordDTO,
  IForgotPasswordDTO,
  ILogOutDTO,
  IRefreshTokenDTO,
  IResetPasswordDTO,
  ISignInAuthorizedResponse,
  ISignInDTO,
  ISignInResponse,
  ISignInVerifyDTO,
} from '@/models/auth.model';

class AuthAPI {
  static signIn(data: ISignInDTO): ApiResponse<ISignInResponse> {
    return httpClient.post<ISignInResponse>(AuthEndpoints.SIGN_IN, data);
  }

  static signInVerify(data: ISignInVerifyDTO): ApiResponse<ISignInResponse & ISignInAuthorizedResponse> {
    return httpClient.post<ISignInResponse & ISignInAuthorizedResponse>(AuthEndpoints.SIGN_IN_VERIFY, data);
  }

  static forgotPassword(data: IForgotPasswordDTO): ApiResponse<void> {
    return httpClient.post<void>(AuthEndpoints.FORGOT_PASSWORD, data);
  }

  static resetPassword(data: IResetPasswordDTO): ApiResponse<void> {
    return httpClient.post<void>(AuthEndpoints.RESET_PASSWORD, data);
  }

  static changePassword(data: IChangePasswordDTO): ApiResponse<string> {
    return httpClient.post<string>(AuthEndpoints.CHANGE_PASSWORD, data);
  }

  static refreshToken(data: IRefreshTokenDTO): ApiResponse<ISignInAuthorizedResponse> {
    return httpClient.post<ISignInAuthorizedResponse>(AuthEndpoints.REFRESH_TOKEN, data);
  }

  static logOut(data: ILogOutDTO): ApiResponse<unknown> {
    return httpClient.post<unknown>(AuthEndpoints.LOG_OUT, data);
  }
}

export default AuthAPI;
